import { render, staticRenderFns } from "./AddFollowup.vue?vue&type=template&id=1b0bc393&scoped=true"
import script from "./AddFollowup.vue?vue&type=script&lang=js"
export * from "./AddFollowup.vue?vue&type=script&lang=js"
import style0 from "./AddFollowup.vue?vue&type=style&index=0&id=1b0bc393&prod&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0bc393",
  null
  
)

export default component.exports